import useIntl from '@/utils/intl'
import { resolveImageUrl } from '@/utils/constants'
import Image from 'next/image' // Assuming you're using Next.js for image optimization

interface DataPackageProps {
  data: Array<{
    id: string
    nameEn: string
    nameMn: string
    icon: string
    roaming_zone?: {
      nameEn: string
      nameMn: string
    }
    SizeEn?: string
    SizeMn?: string
    TimeEn?: string
    TimeMn?: string
    PriceEn?: string
    PriceMn?: string
    SpeedEn?: string
    SpeedMn?: string
    data_packages?: Array<{ // Add this line
      SizeEn?: string
      SizeMn?: string
      TimeEn?: string
      TimeMn?: string
      PriceEn?: string
      PriceMn?: string
      SpeedEn?: string
      SpeedMn?: string
    }> // Specify that it's an array of objects with these properties
  }>
  selectedService: string | null
  locale: 'en' | 'mn'
  IMG_URL: string
}

const DataPacakge: React.FC<DataPackageProps> = ({ data, selectedService, locale, IMG_URL }) => {
  const { translate } = useIntl()
  const filteredData = selectedService != null
    ? data.filter((item) => item.id === selectedService)
    : data
  return (
    <>
      <table className="hidden xl:block w-full text-sm text-left rtl:text-right">
        <thead className="text-xs uppercase bg-surfaceLow w-full">
          <tr className='h-16'>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingRegion')}</th>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingCountry')}</th>
            <th scope="col" className="px-6 py-3 text-center">{translate('roamingDataPackage')}</th>
          </tr>
        </thead>
        <tbody>
          {
            filteredData?.length > 0 
              ? (
                filteredData.map((item, index) => (
                  <tr key={index} className="border-b border-secondaryMidStroke">
                    <th scope="row" className="px-6 py-4 whitespace-nowrap ">
                      <h1 className='text-center font-normal'>
                        {locale === 'en' ? item?.roaming_zone?.nameEn : item?.roaming_zone?.nameMn}
                      </h1>
                    </th>
                    <td className="px-6 py-4 w-full">
                      <div className="ps-3 ml-5 flex items-center justify-start space-x-5">
                        <Image className="w-10 h-10 rounded-full" alt='' width={10} height={10} src={resolveImageUrl(item.icon)} />
                        <div className="font-normal text-start">
                          {locale === 'en' ? item.nameEn : item.nameMn ?? 'No Name'}
                        </div>
                      </div>
                    </td>
                    <td className='w-full'>
                      <div className='flex justify-start gap-2 p-1'>
                        {(item.data_packages != null) && item.data_packages.length > 0
                          ? (
                            item.data_packages.map((item: any, index: any) => (
                              <div key={index} className='flex flex-col justify-between border border-secondaryMidStroke p-2 rounded-xl w-40'>
                                <div key={index} className=''>
                                  <div className='flex justify-between items-center'>
                                    <h1 className='text-sm'>{translate('roamingVolume')}:</h1>
                                    <h1 className='text-end font-bold text-sm'>{locale === 'en' ? item?.SizeEn : item?.SizeMn}</h1>
                                  </div>
                                  <div className='flex justify-between'>
                                    <h1 className='text-sm'>{translate('roamingDuration')}:</h1>
                                    <h1 className='text-end font-bold text-sm'>{locale === 'en' ? item?.TimeEn : item?.TimeMn}</h1>
                                  </div>
                                  <div className='flex justify-between'>
                                    <h1 className='text-sm'>{translate('roamingSpeed')}:</h1><h1 className='text-end font-bold text-sm'>{locale === 'en' ? item?.SpeedEn : item?.SpeedMn}</h1>
                                  </div>
                                  <div className='flex justify-between'>
                                    <h1 className='text-sm'>{translate('roamingTariff')}:</h1><h1 className='text-end font-bold text-sm'>{locale === 'en' ? item?.PriceEn : item?.PriceMn}</h1>
                                  </div>

                                </div>
                              </div>
                            ))
                          )
                          : (
                            <></>
                          )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (<></>)
          }
        </tbody>
      </table>
      {filteredData?.length > 0
        ? (
          filteredData.map((item, index) => (
            <div key={index} className='flex'>
              <div className='block xl:hidden w-full border border-secondaryMidStroke my-5 rounded-xl'>
                <div key={index} className='flex space-y-5 w-full flex-col rounded-xl'>
                  <div className='flex justify-between items-center bg-surfaceLow rounded-t-xl p-5'>
                    <h1 className='text-center'>{item?.roaming_zone?.nameMn}</h1>
                    <div className='flex justify-center items-center space-x-2'>
                      <Image className=' rounded-full' alt='' width={30} height={30} src={resolveImageUrl(item.icon)} />
                      <h1 className='text-center'>{locale === 'en' ? item.nameEn : item.nameMn ?? 'No Name'}</h1>
                    </div>
                  </div>
                  <div className='flex justify-between overflow-x-scroll no-scrollbar'>
                    {(item.data_packages != null) && item.data_packages.length > 0
                      ? (
                        item.data_packages.map((item: any, index: any) => (
                          <div key={index} className='flex flex-col m-2 justify-between border border-secondaryHighStroke p-2 rounded-xl'>
                            <div key={index} className=''>
                              <div className='flex justify-between'>
                                <h1 className='text-sm'>{translate('roamingVolume')}:</h1>
                                <h1 className='text-center font-bold'>{locale === 'en' ? item?.SizeEn : item?.SizeMn}</h1>
                              </div>
                              <div className='flex justify-between'>
                                <h1 className='text-sm'>{translate('roamingDuration')}:</h1>
                                <h1 className='text-center font-bold'>{locale === 'en' ? item?.TimeEn : item?.TimeMn}</h1>
                              </div>
                              <div className='flex justify-between'>
                                <h1 className='text-sm'>{translate('roamingTariff')}:</h1><h1 className='text-center font-bold'>{locale === 'en' ? item?.PriceEn : item?.PriceMn}</h1>
                              </div>
                              <div className='flex justify-between'>
                                <h1 className='text-sm'>{translate('roamingSpeed')}:</h1><h1 className='text-center font-bold'>{locale === 'en' ? item?.SpeedEn : item?.SpeedMn}</h1>
                              </div>
                            </div>
                          </div>
                        ))
                      )
                      : (
                        <></>
                      )}
                  </div>
                </div>

              </div>
            </div>
          ))
        )
        : (
          <></>
        )}
    </>
  )
}

export default DataPacakge
